var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResourcesDataProtection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 25.54,
    viewBox: "0 0 30 25.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DATA_PROTECTION",
    "data-name": "DATA PROTECTION",
    transform: "translate(-1 -3.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19647",
    "data-name": "Path 19647",
    d: "M6.93,24.68a.756.756,0,0,0,.15.01h.86V20.06a2.5,2.5,0,0,1,2.33-2.49,5.751,5.751,0,0,1,11.46,0,2.494,2.494,0,0,1,2.33,2.49v4.63h.86a.756.756,0,0,0,.15-.01,6.994,6.994,0,0,0-.58-13.89A8.548,8.548,0,0,0,16,3.23a8.558,8.558,0,0,0-8.49,7.56,6.994,6.994,0,0,0-.58,13.89Z",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19648",
    "data-name": "Path 19648",
    d: "M16,13.81a4.259,4.259,0,0,0-4.25,4.25v1H10.44a1,1,0,0,0-1,1v7.71a1,1,0,0,0,1,1H21.56a1,1,0,0,0,1-1V20.06a1,1,0,0,0-1-1H20.25v-1A4.259,4.259,0,0,0,16,13.81Zm2.25,5.25h-4.5v-1a2.25,2.25,0,1,1,4.5,0Z",
    fill: "#7dbaab"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcesDataProtection);
export default __webpack_public_path__ + "static/media/Resources-DATA_PROTECTION.f68d32b6d4b07342ebb9ed1fcc19d5ba.svg";
export { ForwardRef as ReactComponent };